<template>
  <div v-if="order" class="container-fluid">
    <h1 class="mr-auto"><back-button to="/orders/equipment"/>Заявка на детали и оборудование</h1>
    <hr>
    <div>
      <div><strong>ФИО оператора:</strong> {{order.user | fullName}}</div>
      <div><strong>Статус:</strong> {{order.status.description}}</div>
      <div><strong>Дата оформления:</strong> {{order.date | formatDate}}</div>
    </div>

    <div class="table-full-width mt-2">
      <table class="table">
        <thead>
        <tr>
          <th colspan="2">Оборудование</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="component in order.parts_request">
          <td>{{component.detail.name}}</td>
          <td>{{component.amount + ' ' + component.detail.measure}}</td>
        </tr>
        </tbody>
      </table>
        <table class="table">
          <thead>
          <tr>
            <th colspan="2">Дополнительное оборудование</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="component in order.extra_parts_request">
            <td>{{component.detail.name}}</td>
            <td>{{component.amount + ' ' + component.detail.measure}}</td>
          </tr>
          </tbody>
        </table>
    </div>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    metaInfo: {title: 'Заявка на детали и оборудование'},
    props: {
      id: {
        required: true,
      },
    },
    data () {
      return {}
    },
    asyncComputed: {
      order () {
        return api
          .get(`orders/details/${this.id}`)
          .then(({data}) => data.data)
      },
    },
  }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/assets/js/pages/orders/equipment/_id.vue